import React, {useCallback, useEffect} from 'react';
import { FormState } from 'react-hook-form';
import AppTooltip from '@/app/components/atomic/molecules/AppTooltip';

interface InputErrorProps {
    formState: any;
    fieldName: string;
    isFocused: boolean;
    onError: (error: any) => void;
    children: React.ReactNode;
}

const InputError: React.FC<InputErrorProps> = ({ formState, fieldName, isFocused, children, onError }) => {
    const getError = useCallback(() => {
        const fieldErrors = formState?.errors?.[fieldName];
        return fieldErrors;
    }, [formState?.errors, fieldName]);

    useEffect(() => {
        onError(getError());
    }, [getError, onError]);

    return (
        <AppTooltip
            isOpen={!!(isFocused && getError())}
            label={getError()?.message as string}
        >
            {children}
        </AppTooltip>
    );
};

export default InputError;